import * as React from "react";
import { forwardRef } from "react";
const SvgOutOfOffice = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 23, height: 23, rx: 4, fill: "#E8FEFF", stroke: "#9DD5D8" }));
const ForwardRef = forwardRef(SvgOutOfOffice);
export { ForwardRef as ReactComponent };
